/*
 * @Author: 范朝阳
 * @Date: 2020-12-18 16:21:53
 * @LastEditTime: 2020-12-21 17:10:34
 * @LastEditors: 范朝阳
 * @Description: 修改描述
 * @FilePath: /trunk/src/directive/index.js
 */
import Vue from 'vue'
import permission from '@/directive/permission'

Vue.use(permission)
